import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import Modals from '../../../Modals/Modals';
import { mapStateToProps, mapDispatchToProps } from '../../../Modals/Modals.container';
export default connectMediaStore(mapStateToProps, mapDispatchToProps)(Modals);
